import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from "vue-router";
import { useAppStore } from "@/store/AppStore";
import { useAuthStore } from "@/store/AuthStore";
import ApplicationBar from "@/components/ApplicationBar.vue";
import LeftBar from "@/components/LeftBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const authStore = useAuthStore();
const appStore = useAppStore();

router.beforeEach(() => {
  if (authStore.isAuthenticated && authStore.isTokenExpire) {
    authStore.logout();
    router.push("/login");
  }

  appStore.updateLeftBarDrawer();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_content = _resolveComponent("v-content")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(ApplicationBar),
      _createVNode(LeftBar),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_content, { style: {"margin-top":"46px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})